// extracted by mini-css-extract-plugin
export var changeIcon = "_6g-4";
export var container = "_6g-0";
export var divider = "_6g-7";
export var externalLinkIcon = "_6g-1";
export var green = "_6g-5";
export var helpCircleIcon = "_6g-3";
export var iconButton = "_6g-2";
export var red = "_6g-6";